import { mutator } from 'satcheljs';
import { onUserContextChanged } from '../actions';
import { getAppStore } from '../store/store';

mutator(onUserContextChanged, msg => {
  getAppStore().userContext = msg.userDetails;
});